import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, currencyMask, phoneMask } from '~/utils/masks';

export const HeaderInactiveCards = [
  {
    id: 1,
    value: 'Nome completo',
    maxChar: 20,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 13,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Celular',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'E-mail',
    maxChar: 15,
  },
  {
    id: 5,
    value: 'Operador(a) de Venda',
    maxChar: 17,
  },
  {
    id: 6,
    value: 'Canal',
    maxChar: 9,
    textAlign: 'center',
  },
  {
    id: 7,
    value: 'Valor limite',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'Aprovação',
    maxChar: 13,
    textAlign: 'center',
  },
];

export const BodyInactiveCards = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 20,
      },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 13,
        textAlign: 'center',
      },
      {
        value: phoneMask(i.celular).masked,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.email,
        maxChar: 15,
      },
      {
        value: i.operador,
        maxChar: 17,
      },
      {
        value: i.origem,
        maxChar: 9,
        textAlign: 'center',
      },
      {
        value: `R$ ${currencyMask(i.valorLimite)}`,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.dataAprovacao
          ? moment(i.dataAprovacao).format('DD/MM/YYYY')
          : '-',
        maxChar: 13,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
